import locationOwnerFilterSlice from './locationOwnerFilters-slice';
export const { setActiveLocationOwnerFilters, resetActiveLocationOwnerFilters, resetState } =
  locationOwnerFilterSlice.actions;

export default locationOwnerFilterSlice;
